/** Checkbox on add / pre-login edit: invite user to set password and sign in. */
export const PORTAL_USER_SIGN_UP_EMAIL_CHECKBOX_LABEL = 'Send sign-up email';

export const PORTAL_USER_SIGN_UP_EMAIL_CHECKBOX_TOOLTIP =
  'When checked, we email this person a link to set their password and sign in. If you leave this unchecked, you can send the sign-up email later from the user list.';

export const PORTAL_USER_PASSWORD_RESET_EMAIL_CHECKBOX_LABEL = 'Send password reset email';

export const getResendPortalUserEmailActionLabel = (hasLoggedIn: boolean): string =>
  hasLoggedIn ? 'Send password reset email' : 'Send sign-up email';

export const getResendPortalUserEmailSuccessMessage = (hasLoggedIn: boolean): string =>
  hasLoggedIn ? 'Password reset email sent.' : 'Sign-up email sent.';
